<template>
  <div class="services">
    <p class="scroll" @click="scrollLeft();">
     <span></span>
    </p>
    <div id="line" class="timeline-wrapper container">
      <div class="inner">
        <div class="timeline">
          <div
            class="time"
            :class="{'active': time === selectTime}"
            v-for="(time, index) in timeline" :key="index"
            @click.prevent="changeTime(time)"
          >
            {{ time }}
          </div>
        </div>
      </div>
    </div>
    <p class="scroll2" @click="scrollRight();">
     <span></span>
    </p>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    timeline: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState([
      'selectTime'
    ])
  },
  methods: {
    ...mapMutations([
      'setTimeLine'
    ]),
    changeTime (time) {
      this.setTimeLine(time)
    },
    scrollLeft () {
      var scrollLeft = document.getElementById('line')
      scrollLeft.scrollLeft -= 457
    },
    scrollRight () {
      var scrollRight = document.getElementById('line')
      scrollRight.scrollLeft += 457
    }
  }
}
</script>

<style lang="sass" scoped>
.services
  position: relative
.services .scroll
  position: absolute
  bottom: 1em
  width: 3em
  height: 3em
  span
    width: 1em
    height: 1em
    position: absolute
    top: 70%
    left: -55%
    transform: rotate(45deg)
    border-left: 3px solid #000
    border-bottom: 3px solid #000
    z-index: 2
    animation: popping-arrow 2s infinite ease-out
.services .scroll2
  position: absolute
  bottom: 1em
  width: 3em
  height: 3em
  span
    width: 1em
    height: 1em
    position: absolute
    top: 70%
    left: 2400%
    transform: rotate(225deg)
    border-left: 3px solid #000
    border-bottom: 3px solid #000
    z-index: 2
    animation: popping-arrow 2s infinite ease-out
@media screen and (max-width: 979px)
  .scroll
    display: none
  .scroll2
    display: none
.timeline-wrapper
  overflow-x: scroll
  -webkit-overflow-scrolling: touch
  &::-webkit-scrollbar
    display: none
  .inner
    -webkit-overflow-scrolling: touch
  .timeline
    display: flex
    .time
      flex-shrink: 0
      display: flex
      justify-content: center
      align-items: center
      height: 40px
      padding: 0 8px
      border-radius: 20px
      font-size: 25px
      cursor: pointer
      &:nth-child(n+2)
        font-size: 25px
        margin-left: 5px
      &.active
        font-size: 25px
        color: #fff
        background-color: $green
    &::after
      content: ''
      display: block
      width: 20px
      flex-shrink: 0
</style>
